const convertRgbaToHex = require('../convertRgbaToHex');
const convertHsvToRgb = require('../convertHsvToRgb');

/**
 * Converts hsv color to hex string
 * @param {Object} hsv - hsv object representation
 * @returns {String} hex color representation
 */
const convertHsvToHex = ({ h, s, v }) => {
    const { r, g, b } = convertHsvToRgb(h, s, v);

    return convertRgbaToHex({ r, g, b });
};

module.exports = convertHsvToHex;
